import { request } from '@app/http/request'
import { appConfig } from '@app/shared/config'
import type { SpResponse } from '@backend-models/common/request/sp-response'
import type { GetContentSettingsResponse } from '@backend-models/content-settings/get/get-content-settings-response'
import type { UpsertContentSettingsRequest } from '@backend-models/content-settings/upsert/upsert-content-settings-request'

export const getContentSettings = async (hideLoading = false): Promise<SpResponse<GetContentSettingsResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/content-settings`, { hideLoading, auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}

export const saveContentSettings = async (data: UpsertContentSettingsRequest): Promise<SpResponse<GetContentSettingsResponse | null>> => {
  try {
    const req = await request(`${appConfig.api}/content-settings`, { method: 'POST', json: true, body: JSON.stringify(data), auth: true })
    const res = await req.json()
    return res
  } catch (error) {
    console.error(error)
    return { data: null, success: false }
  }
}
